export default __webpack_public_path__ + "static/media/log40.04de3c81.png";